import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AutoComplete, Input, Drawer, Tag, Select, Form
} from "antd";
import './LocationFilter.css';
import FilterState from "./state.Filter";
import { fetchKeySearchDynamicLocation } from "../../../../redux/actions";
import { indexOf } from "lodash";
const State = ({ 
    setCheck, 
    check,
    emptyCountryInput,setEmptyCountryInput,
    searchLocationFilter,
    city,region,
    setCheckCountryId,checkCountryId,
  setcountryObj,
  countryObj,
  fromCandMkt,
  removeQuery
}) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  // const [locationValue, setLocationValue] = useState([]);
  const [visible, setVisible] = useState(false);

  // const filters = useSelector(state => state.searchSkillListingReducer.filters);
  const stateSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.stateSuggestions
  );
  const regionSuggestions = useSelector(
    (state) => state.searchSkillListingReducer.regionSuggestions
  );
  const locations = useSelector(
    (state) => state.searchSkillListingReducer.locations
  );
  const [selectedItems, setSelectedItems] = useState([]);
  const [valueCheck,setValueCheck] = useState(check.map(item => item.name))
  const [valueCheckId,setValueCheckId] = useState(check.map(item => item.id))
  const [isSelectVisible, setIsSelectVisible] = useState(false);
useEffect(()=>{
  setValueCheck(check.map(item => item.name))
  setValueCheckId(check.map(item => item.id))
},[check])

 

  const showDrawer = () => {
    setVisible(true);
    setIsSelectVisible(false);
  };

  const onClose = () => {
    setVisible(false);
    setIsSelectVisible(false);
  };

  const handleCountryChange = (flag) => {
    if (flag) {
      if (emptyCountryInput === "") {
        setEmptyCountryInput();
      }
    }
    if (!flag) {
      setEmptyCountryInput("");
    }
    setVisible(flag);
  };

  const containerStyle = {
    position: "relative",
    height: "100vh !important",
    overflow: "hidden",
    // textAlign: 'center',
  };
  

  // const valueCheck = check.map((item) => item.name).join(", ");
  const valueId = check.map((item) => item.id);

  useEffect(() => {
    if (
      check.length === 0 &&
      !visible &&
      region.length === 0 &&
      city.length == 0
    ) {
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params))
    } else if(check.length > 0 && !visible){
      searchLocationFilter.obj['CountryId'] = valueCheckId
      const params = {
        body: searchLocationFilter,
      };
      dispatch(fetchKeySearchDynamicLocation(params));
    }
  },[visible])





  // const valueCheck = check.map(item => item.name).join(', ');


  const handleDeselect=(deselectedValue)=>{
    const updatedValues = check.filter((value) => value.name!== deselectedValue);
    setCheck(updatedValues);
    setValueCheck(updatedValues)

    //for ids and checked values
    const deselectedIndex =  check.findIndex(value => value.name == deselectedValue)
    setCheckCountryId(checkCountryId.filter(((val,index) => index!== deselectedIndex))) 
  }



  return (
    <div className="search-location-filter-mobile">
      <Drawer
        className="location-drawer"
        onClose={onClose}
        visible={visible}
        closable={true}
        placement={"top"}
        afterOpenChange={(e) => {
          handleCountryChange(e);
        }}
        contentWrapperStyle={containerStyle}
        title={"Select country/countries"}
      >
        <FilterState
          setcountryObj={setcountryObj}
          countryObj={countryObj}
          setcheck={setCheck}
          check={check}
          setCheckCountryId={setCheckCountryId}
          checkCountryId={checkCountryId}
          mobileFilter={true}
          setVisible={setVisible}
          fromCandMkt={fromCandMkt}
          emptyCountryInput={emptyCountryInput}
          searchLocationFilter={searchLocationFilter}
        />
      </Drawer>
     
      {/* <Input className="input"
        value={valueCheck}
        onClick={showDrawer}
        type={'input'} placeholder="Search country" />  */}


<Form>
      <Form.Item>
        <Select
         value={valueCheck}
          placeholder="Search country"
          className="input"
          mode="multiple"
          bordered={false}
          onDeselect={handleDeselect}
          onClick={showDrawer}
          showSearch
          listHeight={160}
          open={isSelectVisible}
        >
        </Select>
      </Form.Item>
    </Form>
    </div>
  );
};
export default State;
